import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  iconButton: {
    padding: "10px",
  },
}));
